import {Component, ViewChild} from '@angular/core';
import {CommonModule} from "@angular/common";
import {
    DxButtonModule,
    DxDataGridComponent,
    DxDataGridModule,
    DxFormModule,
    DxTabsModule,
    DxTemplateModule
} from "devextreme-angular";
import {DurationSettingGridViewDto} from "@services/web-api-client";
import {GridPageComponent} from "../../common/grid-page.component";
import {ColorSelectBoxComponent} from "../../../components/library/color-select-box/color-select-box.component";
import { ColorSwatchComponent } from "../../../components/library/color-swatch/color-swatch.component";
import EnumUtils from "../../../shared/enum-utils";

@Component({
    selector: 'app-duration-settings',
    imports: [
        CommonModule,
        DxDataGridModule,
        DxButtonModule,
        DxFormModule,
        DxTemplateModule,
        DxTabsModule,
        ColorSelectBoxComponent,
        ColorSwatchComponent
    ],
    templateUrl: './duration-settings.component.html',
    styles: [
        `.grid {
            height: calc(100vh - 180px);
        }`
    ],
})
export class DurationSettingsComponent extends GridPageComponent<DurationSettingGridViewDto> {
    @ViewChild(DxDataGridComponent, { static: false }) grid!: DxDataGridComponent;

    protected tabs = [
        { id: '210', text: '210 Recoup' },
        { id: '216', text: '216 Material' },
        { id: '260', text: '260 Putaway' },
        { id: '999', text: '999 Short Picks' },
        { id: 'LT22', text: 'LT22 Refill' }
    ];
    protected selectedTabIndex = 0;

    constructor() {
        super();
        this.init(DurationSettingGridViewDto);
    }

    dataSource = this.dataSources.durationSettings(this.tabs[this.selectedTabIndex].id);

    protected override exportName: string = "DurationSettings";

    addNew() {
        this.grid.instance.addRow();
    }

    onTabClick(e: any) {
        this.selectedTabIndex = e.itemIndex;
        this.dataSource = this.dataSources.durationSettings(e.itemData.id);
    }

    onInitNewRow(e: any) {
        e.data.storageTypeCode = this.tabs[this.selectedTabIndex].id;
    }

    onRowUpdating(e: any) {
        e.newData = Object.assign({}, e.oldData, e.newData);
    }

    onRowDblClick(e: any) {
        if (e.rowType === "data") {
            e.component.editRow(e.rowIndex);
        }
    }

    get isShortPicks(): boolean {
        return !!this.tabs[this.selectedTabIndex] && (
            this.tabs[this.selectedTabIndex].id === '999' ||
            this.tabs[this.selectedTabIndex].id === 'LT22'
        );
    }

    get fromCaption(): string {
        return `From (${this.isShortPicks ? 'minutes' : 'days'})`;
    }

    get toCaption(): string {
        return `To (${this.isShortPicks ? 'minutes' : 'days'})`;
    }

    get selectedTabName(): string {
        return this.tabs && this.tabs[this.selectedTabIndex] ? this.tabs[this.selectedTabIndex].text : '';
    }

    getColor(colorName: string): string {
        return EnumUtils.getBootstrapColorVar(colorName);
    }
}
